import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle } from '../styles/marketing.styles'

export const CaseStudiesPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <PageTitle>Case Studies</PageTitle>
      <PageSubtitle>Customer success stories. Coming soon.</PageSubtitle>
    </MarketingPageContainer>
  </MarketingLayout>
)
